import React from 'react';
import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ModalBody = styled.div`
	text-align: center;
	margin: 2px;
`;

export const MetadataSummary = styled(({ children, ...props }) => (
	<table {...props}>
		<tbody>{children}</tbody>
	</table>
))``;

export const MetadataSummaryLine = styled.tr``;

export const SummaryLabel = styled.td`
	color: ${colors.grey500};
	font-size: 16px;
	line-height: 32px;
	font-weight: normal;
	padding: 12px 64px 12px 12px;
`;

export const SummaryValue = styled.td`
	color: ${colors.black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	height: 56px;
`;

export const ValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 177px;
	margin-bottom: 19px;
	padding-right: 32px;
`;